import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';

// The last panel: what stops someone signing up, answered plainly
const QUESTIONS = [
  ['Does it invoice my clients?',
    'We connect with your Xero account, or let you export to any accounting software so you can invoice your clients.'],
  ['I’ve hired out my gear for years. Do I start from zero?',
    'No. Bring in what your gear has already earned from a Xero export or a spreadsheet, and your numbers are true from day one. Or book onboarding and it’s done for you.'],
  ['Can I try it first?',
    'Yes. The demo is a whole working kit, with jobs, estimates and earnings already in it. No account needed.'],
  ['What if I need some help?',
    'Ask us anything from Help inside the app, and a person answers. If you’d rather not set up your gear yourself, book onboarding and we’ll do it with you.'],
];

export function Faq() {
  return (
    <Accordion type="single" collapsible className="border-t border-line">
      {QUESTIONS.map(([q, a]) => (
        <AccordionItem key={q} value={q} className="border-line">
          <AccordionTrigger className="py-6 text-lg sm:text-xl font-normal hover:no-underline">{q}</AccordionTrigger>
          <AccordionContent className="pb-6 pr-8 text-base sm:text-lg text-muted-foreground leading-snug">{a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
